<template>
    <div
    class="modal right fade trader-info"
    id="trader-info"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"       
    >
    <div class="modal-dialog modal-dialog-centered modal-md" role="document">
        <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title" >Edit Account</h5>
            <button type="button" class="close"  @click="$emit('close')">
            <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <form>
                <div class="form-row">
                    <div class="form-group col-md-6">
                        <label for="accountno required">Account No *</label>
                        <div class="input-group mb-3">
                            <input :disabled="true" type="text" class="form-control" id="accountno" placeholder="Enter Account No" v-model="accountData.account">
                        </div>
                    </div>
                    <div class="form-group col-md-6">
                        <label for="accountno">Is Margin</label>
                        <div class="input-group mb-3">
                            <select class="form-control"  v-model="accountData.isMargin" >
                                <option value="YES">YES</option>
                                <option value="NO">NO</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-6" >
                        <label for="accountno">PMP</label>
                        <div class="input-group mb-3">
                            <select class="form-control"  v-model="accountData.pmp" >
                                <option value="YES">YES</option>
                                <option value="NO">NO</option>
                            </select>
                        </div>
                    </div>
                    <div class="form-group col-md-6">
                        <label for="accountno">FBSI Short Name</label>
                        <div class="input-group mb-3">
                            <input  type="text" class="form-control" id="accountno" placeholder="FBSI Short Name" v-model="accountData.fbsiShortName">
                        </div>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-6">
                        <label for="accountno">Note</label><br>
                        <label for="accountno">Last updated on : <span class="text-info">{{accountData.noteLastEditedDate ? moment(accountData.noteLastEditedDate).format('MM/DD/YYYY h:mm:ss a') : ''}}</span></label>
                        <div class="input-group mb-3">
                            <textarea  class="form-control" v-model="accountData.note" rows="3" maxlength="750"></textarea>
                        </div>
                    </div>
                    <div class="form-group col-md-6" >
                        <label for="accountno"></label>
                        <div class="input-group mb-3 is-margin">
                            <input type="checkbox" class="form-check-input" v-model="accountData.export">
                            <label class="form-check-label" for="inlineCheckbox1">Active Account</label>
                        </div>
                    </div>
                    <div class="form-group col-md-6" >
                        <label for="accountno">Maturity</label>
                        <div class="input-group mb-3">
                            <select class="form-control"  v-model="accountData.maturity" >
                                <option value="Short">Short</option>
                                <option value="Medium">Medium</option>
                                <option value="Long">Long</option>
                                <option value="All">All</option>
                            </select>
                        </div>
                    </div>
                    <div class="form-group col-md-6" >
                        <label for="accountno">Spread</label>
                        <div class="input-group mb-3">
                            <select class="form-control"  v-model.number="accountData.spread" >
                                <option value="0.5">0.5</option>
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                            </select>
                        </div>
                    </div>
                    <div class="form-group col-md-6" >
                        <label for="accountno">Contact</label>
                        <div class="input-group mb-3">
                            <select class="form-control"  v-model="accountData.contact" >
                                <option value="YES">YES</option>
                                <option value="NO">NO</option>
                            </select>
                        </div>
                    </div>
                    <div class="form-group col-md-6" >
                        <label for="accountno">EOD</label>
                        <div class="input-group mb-3">
                            <select class="form-control"  v-model="accountData.eod" >
                                <option value="YES">YES</option>
                                <option value="NO">NO</option>
                            </select>
                        </div>
                    </div>
                    <div class="form-group col-md-6" >
                      <label for="accountno">Primary Rep</label>
                      <div class="input-group mb-3">
                        <multiselect 
                            v-model="primaryRep" 
                            placeholder="Select" 
                            :options="representativeData" 
                            :multiple="false" 
                            label="firstName" 
                            track-by="id" >
                            </multiselect>
                      </div>
                  </div>
                  <div class="col-md-6" >
                      <label for="accountno">Secondary Rep</label>
                      <div class="input-group mb-3">
                        <multiselect 
                            v-model="secondaryRep" 
                            placeholder="Select" 
                            :options="representativeData" 
                            :multiple="false" 
                            label="firstName" 
                            track-by="id" >
                            </multiselect>
                      </div>
                  </div>
                </div>    
                <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                <p v-if="errors.length">
                    <ul>
                    <li class="alert alert-danger" role="alert" v-for="error in errors" v-bind:key="error">{{ error }}</li>
                    </ul>
                </p>
                <div class="modal-footer bid">
                    <button type="button" class="btn btn-secondary"  @click="$emit('close')">Close</button>
                    <button type="button" class="btn btn-primary" @click="updateAccount()">UPDATE ACCOUNT</button>
                </div>
            </form>
        </div>
        </div>
    </div>
    </div>
</template>

<script>
    import authService from "@/authService";
    import config from "@/config";

    export default {
        name: 'accountAddmodal',
        components :{
            
        },
        props: ['accountData'],
        data() {
            return {
                loading : false,
                errors: [],
                representativeData : [],
                primaryRep : null,
                secondaryRep : null,
            };
        },
        methods: {   
            updateAccount(){
                let isValid = this.checkForm();
                if (isValid) {
                    this.loading = true;
                    var addData = { ...this.accountData};
                    if(addData.pmp == 'YES'){
                        addData.pmp = true
                    }else{
                        addData.pmp = false
                    }
                    if(addData.isMargin  == 'YES'){
                        addData.isMargin  = true
                    }else{
                        addData.isMargin  = false
                    }
                    if(addData.contact  == 'YES'){
                        addData.contact  = true
                    }else{
                        addData.contact  = false
                    }
                    if(addData.eod  == 'YES'){
                        addData.eod  = true
                    }else{
                        addData.eod  = false
                    }
                    addData.primaryRep = this.primaryRep ? this.primaryRep.id : 0
                    addData.secondaryRep = this.secondaryRep ? this.secondaryRep.id : 0
                    delete addData.primaryRepName;
                    delete addData.secondaryRepName;
                    delete addData.primaryRepId;
                    delete addData.secondaryRepId;
                    delete addData.accountType;

                    const auth = {
                        headers: { 'org-token' : authService.getOrgToken()  }
                    };
                    this.$http
                    .put(config.baseUrlBidSide + "/account?cognitoSub="+authService.getUser().cognitoSub, addData, auth)
                    .then(() => {
                        this.loading = false;              
                        this.$emit('close');               
                    })
                    .catch(() => {
                        this.loading = false;              
                    });
                }
            },
            checkForm(){
                this.errors = [];
                if(this.primaryRep && this.secondaryRep)
                    if (this.primaryRep.id === this.secondaryRep.id) {
                        this.errors.push("Primary and secondary representative can't be same");
                        return false;
                    }
                return true
            },
            getRepresentativeList() {
                this.loading = true;
                const auth = {
                    headers: {'org-token' : authService.getOrgToken() }
                };
                let url = "/money-line/representative-list";
                this.$http
                    .get(
                    config.baseUrlAutoBidder +
                        url,
                        auth
                    )
                    .then(result => {
                        this.representativeData = result.data;
                        this.loading = false;
                        this.primaryRep = this.representativeData.find(element => element.id  == this.accountData.primaryRepId);
                        this.secondaryRep = this.representativeData.find(element => element.id   == this.accountData.secondaryRepId);
                    })
            }

        },
        created(){
            this.getRepresentativeList()
        }
    };
    </script>
    <style>
    .modal .form-control{
        height: auto;
    }
    .is-margin{
        margin: 37px;
    }
    </style>